import * as Factory from 'factory.ts'
import faker from 'faker'
import moment from 'moment'

import { OrderStatusEnum } from '@webapp/models/enums'
import { type ProcureOrderItem } from '@webapp/models/ProcureOrderItem'
import { AccountMock } from './account.factory'
import { AccountCodeMock } from './accountcode.factory'
import { CurrencyMock } from './currency.factory'
import { UserMock } from './user.factory'
import { VendorMock } from './vendor.factory'

export const ProcureOrderItemMock = Factory.Sync.makeFactory<ProcureOrderItem>({
  id: Factory.each(() => faker.random.number()),
  PO: [],
  PO_line_num: 1,
  account: Factory.each(() => AccountMock.build()),
  accountCode: '',
  account_id: null,
  active: true,
  approval_history: [],
  approved_currency_rate: '1.00000',
  approved_datetime: moment().toISOString(),
  approved_price: Factory.each(() => faker.commerce.price()),
  approved_quantity: Factory.each(() => faker.random.number()),
  attachments: [],
  item_attachments: [],
  catalog_item: null,
  category: null,
  comments: [''],
  created_at: Factory.each(() => faker.date.past(10).toISOString()),
  currency: CurrencyMock.build(),
  custom_fields: [],
  dateInvoiced: Factory.each(() => faker.date.past(10).toISOString()),
  date_required: Factory.each(() => faker.date.future().toISOString()),
  external_id: null,
  flags: null,
  has_sibling_items: false,
  hot: false,
  is_active: true,
  last_changed_by: UserMock.build().id,
  last_modified: Factory.each(() => faker.date.past(10).toISOString()),
  lineComment: '',
  line_comment: '',
  logs: [],
  name: Factory.each(() => faker.commerce.productName()),
  num: Factory.each(() => faker.random.number().toString()),
  orderNum: Factory.each(() => faker.random.number()),
  order_description: Factory.each(() => faker.commerce.productAdjective()),
  order_status: OrderStatusEnum.APPROVED,
  order_uuid: Factory.each(() => faker.random.uuid()),
  po_note: '',
  po_version: 1,
  pref_vendor: Factory.each(() => VendorMock.build()),
  price: Factory.each(() => faker.commerce.price()),
  quantity: Factory.each(() => faker.random.number(100)),
  purchased_currency_rate: '1.00000',
  receive_log_count: 0,
  receivedFailQty: 0,
  receivedPassQty: 0,
  requester: null,
  sku: '',
  spend_allocation: null,
  status: 0,
  submitted_date: Factory.each(() => faker.date.past(10).toISOString()),
  total_cost: Factory.each(() => faker.commerce.price()),
  unit: 'ea',
  updated_at: Factory.each(() => faker.date.past(10).toISOString()),
  vendor: null,
})
  .withDerivation1(['pref_vendor'], 'vendor', (prefVendor) => {
    return prefVendor.name
  })
  .withDerivation1(['account'], 'account_id', (account) => {
    return account.id
  })
  .withDerivation2(['price', 'quantity'], 'total_cost', (price, quantity) => {
    return (parseFloat(price) * quantity).toFixed(2)
  })
